import AddActivities from './AddActivities';

export default AddActivities;
